import { UiCButtonModule } from '@wlp/ui-c-button';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { environment } from 'src/environments/environment';

import { InterceptService } from '../../../../../../../core/intercept/intercept.service';
import { InsertNumberComponent } from './insert-number/insert-number.component';
import { RechargePhoneRoutingModule } from './recharge-phone-routing.module';
import { RechargeValueComponent } from './recharge-value/recharge-value.component';
import { RechargeResumeComponent } from './recharge-resume/recharge-resume.component';
import { UiCRechargePhoneResumeModule } from '@wlp/ui-c-recharge-phone-resume';
import { UiCRechargePhoneNumberModule } from '@wlp/ui-c-recharge-phone-number';
import { UiCRechargePhoneValueModule } from '@wlp/ui-c-recharge-phone-value';
import { UiBsRechargePhoneModule } from '@wlp/ui-bs-recharge-phone';
import { RechargePhonePage } from './recharge-phone.page';
import { HeaderUserInfoModule } from '@wlp/ui-c-header-user-info';
import { UiCListDataModule } from '@wlp/ui-c-list-data';
import { UiCTextValueModule } from '@wlp/ui-c-text-value';

@NgModule({
  declarations: [
    InsertNumberComponent,
    RechargeValueComponent,
    RechargeResumeComponent,
    RechargePhonePage
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    UiBsTranslateModule.forRoot({ device: 'WEB', config: environment }),
    RechargePhoneRoutingModule,
    UiCButtonModule,
    UiCRechargePhoneNumberModule,
    UiCRechargePhoneResumeModule,
    UiCRechargePhoneValueModule,
    UiBsRechargePhoneModule,
    HeaderUserInfoModule,
    UiCListDataModule,
    UiCTextValueModule

  ],
  entryComponents: [],
  providers: [
    InterceptService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true,
    },
  ]
})
export class RechargePhoneModule { }
